import * as React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { connect } from "react-redux";
import { editProfile } from '../../app/store/actions/authActions';
import { centered_flex_box, MainInput } from '../../app/components/Styles';
import { marketingColors, marketingPhoneFieldSx } from '../../app/components/tickitMarketingTheme';
import { MarketingFormCard, MarketingButton } from '../../app/components/marketing';
import MuiPhoneNumber from 'material-ui-phone-number';

export const EditProfile = ({ editProfile, user, isLoading }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    editProfile({
      email: data.get('email'),
      phoneNumber: data.get('phoneNumber'),
      newsletter: data.get('newsletter'),
    });
  };

  if (isLoading) {
    return (
      <Box sx={{ ...centered_flex_box, py: 4 }}>
        <CircularProgress sx={{ color: marketingColors.p700 }} />
      </Box>
    );
  }

  return (
    <MarketingFormCard hideHeader sx={{ boxShadow: 'none', border: 'none', width: '100%' }}>
      <Box component="form" onSubmit={handleSubmit}>
        <MainInput
          margin="normal"
          fullWidth
          value={user?.name}
          readOnly
          label="Full Name"
          sx={{ my: 1 }}
        />
        <MainInput
          margin="normal"
          fullWidth
          type="email"
          defaultValue={user?.email}
          name="email"
          label="Email"
          id="email"
          sx={{ my: 1 }}
        />
        <MuiPhoneNumber
          sx={marketingPhoneFieldSx}
          margin="normal"
          fullWidth
          defaultValue={user?.phoneNumber}
          name="phoneNumber"
          label="Phone Number"
          variant="outlined"
          defaultCountry="eg"
          preferredCountries={['eg', 'us']}
          countryCodeEditable={false}
          disableAreaCodes
        />
        <MarketingButton type="submit" sx={{ mt: 3 }}>
          Save changes
        </MarketingButton>
      </Box>
    </MarketingFormCard>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.auth?.isLoading,
});

const mapDispatchToProps = { editProfile };

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);
